import axios from "axios";
import sha256 from "crypto-js/sha256";
import { ss } from "./constant";

// create an axios instance
const service = axios.create({
  baseURL: "",
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
});

// 对返回的数据进行处理，这需要统一进行拦截处理，其它的后续业务逻辑放到具体的入口文件中去拦截处理
service.interceptors.response.use((res) => {
  // 对于需要验证签名的接口，进行签名验证
  if (res?.config?.needSign) {
    const needSignStr = `${ss}${res.data?.nonce}${res.data?.status}${res.data?.ts}`;
    const sign = sha256(needSignStr)?.toString();
    if (sign !== res.data?.sign) {
      // 签名验证失败，弹窗提示
      throw new Error("签名验证失败");
    }
  }
  const data = res.data;
  if (typeof data === "object") {
    const req = res.request;
    data["__axios_metadata"] = {
      noWarning: res.config.noWarning,
    };
    try {
      const url = new URL(req.responseURL);
      data["__axios_metadata"]["urlObj"] = url;
    } catch (e) {
      console.warn(e);
    }
  }
  return res.data;
});

export default service;
